import {
    ApiShopperLandingPageLink,
    DefaultReviewSummarySetting,
} from '@storefronts/common-types'
import type { LandingPageModel } from '../../models/landingPageModel'
import { DEFAULT_REVIEW_COUNT, DEFAULT_REVIEW_RATING } from '../constants'

export const getReviewSummary = (
    landingPage: LandingPageModel,
    lpLink: ApiShopperLandingPageLink,
) => {
    let reviewRating = lpLink.reviews.rating
    let reviewCount = lpLink.reviews.count

    if (
        landingPage.client?.defaultReviewSummary ===
            DefaultReviewSummarySetting.ENABLED &&
        !reviewRating &&
        !reviewCount
    ) {
        reviewRating = DEFAULT_REVIEW_RATING
        reviewCount = DEFAULT_REVIEW_COUNT
    }

    return { reviewRating, reviewCount }
}
